function parseData(response) {
  if ((!response) || response.length == 0) {
    return null;
  }
  else {
    return JSON.stringify(response);
  }
}

function serviceFactory({ api }) {

  const initiateDataExtract = ({ metaData }) =>
    api
      .initiateDataExtract(metaData)
      .then(parseData)
      .catch(parseData);

  const getExtractVolume = ({ inputParam, metaData }) =>
    api
      .getExtractVolume(inputParam, metaData)
      .then(parseData)
      .catch(parseData);

  const getDistinctDates = ({ inputParam, metaData }) =>
      api
        .getDistinctDates(inputParam, metaData)
        .then(parseData)
        .catch(parseData);
  
  return {
    initiateDataExtract,
    getExtractVolume,
    getDistinctDates
  };
}

module.exports = serviceFactory;
